(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.PL8WholesaleCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const TIERS = Object.freeze([10, 20, 30, 40, 50]);
  // Series groups use printing-SKU prefixes, not prefectural boundaries.
  const SERIES_PREFIXES = Object.freeze({
    yokohama: ['JP-YOKOHAMA-'],
    tokyo: ['JP-TOKYO-', 'JP-SHIBUYA-'],
    shonan: ['JP-SHONAN-'],
    osaka: ['JP-OSAKA-'],
    okinawa: ['JP-OKINAWA-']
  });
  function parseQuantity(raw) {
    const text = String(raw ?? '').trim();
    if (text === '') return { valid: true, value: 0 };
    if (!/^[0-9]+$/.test(text)) return { valid: false, value: 0 };
    const value = Number(text);
    return { valid: Number.isSafeInteger(value) && value >= 0 && value <= 50, value };
  }
  function calculate(rawQuantities) {
    const parsed = rawQuantities.map(parseQuantity);
    const invalidIndexes = parsed.flatMap((item, index) => item.valid ? [] : [index]);
    const quantity = parsed.reduce((sum, item) => sum + (item.valid ? item.value : 0), 0);
    const designCount = parsed.filter(item => item.valid && item.value > 0).length;
    const valid = invalidIndexes.length === 0 && TIERS.includes(quantity);
    const unitPrice = valid ? (quantity < 30 ? 2086 : quantity < 50 ? 1937 : 1788) : null;
    const nextTier = invalidIndexes.length === 0 ? TIERS.find(tier => tier > quantity) ?? null : null;
    return { quantity, designCount, valid, invalidIndexes, unitPrice, subtotal: unitPrice === null ? null : quantity * unitPrice, nextTier, remaining: nextTier === null ? null : nextTier - quantity };
  }
  function normalize(text) {
    return String(text).normalize('NFKC').toLocaleLowerCase('ja').trim();
  }
  function matches(item, filters, rawQuantity) {
    const searchable = normalize([item.designName, item.retailSku, item.wholesaleSku, item.countryName].join(' '));
    const words = normalize(filters.query || '').split(/\s+/).filter(Boolean);
    const region = filters.region;
    const prefixes = Object.prototype.hasOwnProperty.call(SERIES_PREFIXES, region) ? SERIES_PREFIXES[region] : null;
    const regionMatch = !region || region === 'all' ||
      (region === 'JP' ? item.countryCode === 'JP' :
        region === 'general' ? item.countryCode === 'ZZ' :
        region === 'overseas' ? item.countryCode !== 'JP' && item.countryCode !== 'ZZ' :
          !!prefixes && prefixes.some(prefix => item.retailSku.startsWith(prefix)));
    const countryMatch = !filters.country || filters.country === 'all' || item.countryCode === filters.country;
    const parsed = parseQuantity(rawQuantity);
    const selected = parsed.valid ? parsed.value > 0 : String(rawQuantity).trim() !== '';
    return words.every(word => searchable.includes(word)) && regionMatch && countryMatch && (!filters.selectedOnly || selected);
  }
  return Object.freeze({ TIERS, parseQuantity, calculate, normalize, matches });
});
